export default function getMainAxisFromPlacement(_0x56f7d2){return['top','bottom']['indexOf'](_0x56f7d2)>=0x0?'x':'y';}